module.exports = __webpack_public_path__ + "img/header-memoireRingsColored.1272ebb.webp";